import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'environments/environment';

import { Observable } from "rxjs";
import { SistemaInterface } from "app/module/sistema-interface";

@Injectable({
	providedIn: "root",
})
export class SistemaService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}sistema/post`, {
				nome: data.value.nome,
				status: data.value.status,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public put(data: any, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url}sistema/${id}/update`, {
				id_sistema: id,
				nome: data.value.nome,
				status: data.value.status,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public delete(data: number, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url}sistema/${id}/update`, {
				id_sistema: id,
				isDeleted: data,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public delete(id: number): Observable<SistemaInterface> {
	//   return this.http
	//     .delete<SistemaInterface>(`${this.url}sistema/${id}/update`, {
	//       id_sistema: data.value.id_sistema,
	//       nome: data.value.nome,
	//       status: data.value.status
	//     })
	//     .pipe(
	//       (res) => res,
	//       (error) => error
	//     );
	// }

	public get(): Observable<Array<SistemaInterface>> {
		return this.http.get<Array<SistemaInterface>>(`${this.url}sistema`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getAtivos(): Observable<Array<SistemaInterface>> {
		return this.http.get<Array<SistemaInterface>>(`${this.url}sistema/ativos`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOne(id: number): Observable<SistemaInterface> {
		return this.http.get<SistemaInterface>(`${this.url}sistema/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
